<template>
    <v-snackbar
        v-model="enabled"
        color="error"
        :timeout="timeout"
        min-width="300px"
        centered
        elevation="24"
        vertical
    >
        <strong style="white-space:pre-line; word-wrap:break-word;">
            {{ message }}
        </strong>
        <template v-slot:action>
            <v-btn
            icon
            @click="close"
            >
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
	name: 'ExpiredSnackbar',
    data () {
        return {
            defaultMessage: 'ログイン有効期間が切れました。ログインしなおしてください。',
            timeout: 5000,
        }
    },
    computed: {
        ...mapState('app', ['expired']),
        enabled: {
            get () {
                return !!this.expired;
            },
            set (val) {
                this.setExpired(val);
            },
        },
        message () {
            if (this.$validator.isString(this.expired)) return this.expired;
            return this.defaultMessage;
        },
    },
    watch: {
        enabled (newVal, oldVal) {
            if (newVal) this.$auth.logout();
        },
    },
    methods: {
        ...mapMutations('app', ['setExpired']),
        close(){
            this.enabled = false;
        }
    }
}
</script>
